import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import SplineChart from "./SplineChart";
import { api, endpoint } from "../../api";
import PieChartsShow from "./PieChartsShow";

const LineChart = ({ data }) => {
  const { userDetails } = useSelector((state) => state.user);
  const [graphData, setGraphData] = useState([])


  const { chartType, chartTitle, locations, xAxis } = data
   // get device data
  const getDeviceChartData = async () => {
    const body = { device: locations[0].device, yAxis: locations[0].yAxis }
    const data = await api.get(endpoint.get_device_chart, {
      params: body,
    })
    console.log({ data })
    if (data.success) {
      setGraphData(data?.results)
    }
  }
  // get location data
  const getLocationChartData = async () => {
    if (locations?.length > 0) {
      const body = locations?.map(item => ({ location: item.location, yAxis: item.yAxis, device: item.device }))
      const data = await api.get(endpoint.get_location_pie, {
        params: { locations: body },
      })
      if (data.success) {
        setGraphData(data?.results)
      }
    }
  }

  useEffect(() => {
    if (chartType === 'Device Chart') {
      getDeviceChartData()
    } else {
      getLocationChartData()
    }

  }, [chartType])

  return (
    <div className="p-3">
      {
        graphData.length > 0 && chartType === 'Location Chart' ? (
          <PieChartsShow
            title={chartTitle}
            data={graphData}
            chartType={chartType}
            type="pie"
          />
        ) : (
          <div>
            <SplineChart
              title={chartTitle}
              data={graphData}
              chartType={chartType}
              type="pie"
            />
          </div>
        )
      }



    </div>
  );
};

export default LineChart;
